import styled from 'styled-components';

import { styledTypography } from '@pkg/primitives';

import { tokens } from '../../tokens';

export const StyledEstValue = styled.div`
    display: grid;
    grid-area: 1 / 1;
    place-content: center;
    place-items: center;
    padding: ${tokens.card.children.padding}px;
`;

export const Interior = styled.div`
    display: flex;
    place-items: center;
    gap: ${tokens.card.children.padding}px;
`;

export const Label = styled.div`
    ${styledTypography.allianceBase};
    font-weight: 700;
    font-size: ${tokens.estValue.label.fontSize}px;
    letter-spacing: -0.02em;
`;
